import FormDialog from "../../components/dialog/form/FormDialog.vue";
import ConfirmDialog from "../../components/dialog/confirm/ConfirmDialog.vue";
import SelectField from "../../components/fields/selectField/SelectField.vue";
import AutocompleteField from "../../components/fields/autocompleteField/AutocompleteField.vue";
import TextField from "../../components/fields/textField/TextField.vue";
import DialogFormPerfil from "./gerenciar-perfis/formPerfil/DialogFormPerfil.vue";
import DialogFuncionalidades from "./gerenciar-perfis/formFuncionalidades/DialogFuncionalidades.vue";
import DialogFormEditar from "./gerenciar-perfis/formEditarPerfil/DialogFormEditar.vue";
import DialogFormExcluir from "./gerenciar-perfis/formExcluirPerfil/DialogFormExcluir.vue";
import DialogAssociar from "./gerenciar-perfis/formAssociar/DialogAssociar.vue";
import DialogPerfilCargos from "./gerenciar-perfis/formCargos/DialogPerfilCargos.vue";
import DialogCargosUsuario from "./gerenciar-perfis/formCargosUsuario/DialogCargosUsuario.vue";
import DialogParametrizar from "./gerenciar-perfis/formParametrizarPerfil/DialogParametrizar";
import PerfilService from "../../services/PerfilService.js";
import ConfirmPasswordDialog from "../../components/dialog/confirmPassword/ConfirmPasswordDialog.vue";
import { AssinaturaMixin } from "../../mixins/assinaturaMixin.js";
import { SnackbarMixin } from "../../mixins/snackbarMixin";
import CargoService from "@/services/CargoService";
import { FeriasService } from "../../services/FeriasService";
import { numeroBmMixin } from "../../mixins/numeroBmMixin";

export default {
  name: "GerenciarUsuarios",
  components: {
    FormDialog,
    ConfirmDialog,
    SelectField,
    AutocompleteField,
    TextField,
    DialogFormPerfil,
    DialogAssociar,
    DialogFuncionalidades,
    ConfirmPasswordDialog,
    DialogFormEditar,
    DialogFormExcluir,
    DialogParametrizar,
    DialogPerfilCargos,
    DialogCargosUsuario

  },

  mixins:[AssinaturaMixin,SnackbarMixin,numeroBmMixin],
  
  data: () => ({
    perfilid: null,
    disabledLotacao: true,
    unidade: null,
    usuarioid: null,
    usersSelecteds: [],
    showDialogConfirmPassword: false,
    activeDialog:false,
    formConfirmPassword: {},
    send: {
      function: () => {},
      params: null,
    },
    dialogShow: {
      associarPerfil: false,
      editPerfil: false,
      deletePerfil: false,
      funcionalidades: false,
      parametrizar_data:false,
      editCargos:false,
      param:false,
      cargoUsuarios:false
    },
    userselected: {},
    options: {
      perfis: [],
      users:[],
    },
    perfiSelectedlid: 0,
    usuarioSelectedId: 0,
    form: {},
    optionsFilter:{
      cargos:[],
      unidade: [],
      lotacao: [],
      tipoUsuario: [],
      postoGraduacao: []

    },
    formEdit:{},
    disable: {
      perfis: false,
      users: false,
    },
    loading: {
      table: false,
      tablePerfis: false,
      tableUsers: false,
      tableCargos: false,
      perfis: false,
      dialog: false,
      field:false,
    },
    tablePerfis: {
      data: [],
      headers: [
        { text: "Perfil", value: "nome", sortable: false, width: "150" },
        { text: "Descrição", value: "descricao", sortable: false },
        {
          text: "",
          value: "cargo",
          align: "center",
          sortable: false,
        },
        { text: "Ações", value: "actions", sortable: true },
      ],
      page: 1,
      pageCount: 1,
    },
    tableUsers: {
      data: [],
      headers: [
        { text: "Matrícula", value: "numero", sortable: false },
        { text: "Nome", value: "nome", sortable: false },
        { text: "Unidade", value: "unidade.nome_abreviado", sortable: false },
        { text: "Perfis", value: "perfisString", sortable: false },
        { text: "Tipo Usuário", value: "servidor_civil", sortable: false },
        { text: "Cargos", value: "cargosString", sortable: false },
        { text: "", value: "cargo", sortable: false },
      ],
      page: 1,
      pageCount: 0,
      totalItems: 0,
      itemsPerPage:20,
      filters: {},
    },

  }),
  beforeMount() {
    this.getPerfisList();
    this.initializeFilters()
  },
  created() {
    this.getPerfisList();
    this.initializeFormConfirmPassword();
    this.initializePermissions();
    this.getUnidadeItems();
    this.getLotacaoItems();

    this.getPerfis();
    this.filterCargos();
    this.filterTipoUsuario();
  },

  async mounted() {

    await this.verificaPermissions();
    await this.getUsers();
    await this.getGraduacaoItems();

    setTimeout(() => {
        this.getPerfisList();
    }, 3000)

  },

  watch: {
    'tableUsers.page': async function(val) {
      this.tableUsers.page = val;
      await this.getUsers(this.createUrlFilters());
    },
    'unidade': function(unidade) {
      if (unidade) {
        this.getLotacoesItems(unidade);
        this.disabledLotacao = false;
        this.tableUsers.filters.unidade = unidade
      } else {
        this.disabledLotacao = true;
        this.unidade = null;
        this.tableUsers.filters.lotacao = null;
        this.tableUsers.filters.unidade = null;
      }
    }
  },

  methods: {
    async verificaPermissions() {
      this.permissions.criar_perfil = await this.verificaPermissaoFuncionalidade(
        69,
      );
      this.permissions.listar_perfil = await this.verificaPermissaoFuncionalidade(
        70,
      );
    },
    async getLotacoesItems(unidade) {
      this.loading.field = true;
      const response = await FeriasService.getLotacaoByUnidade(unidade);
      this.optionsFilter.lotacao = response.map((el) => {
        return {
          text: el.nome,
          value: el.id,
        };
      });
      this.loading.field = false;
    },
    initializePermissions() {
      this.optionsFilter.cargos.push({
        value:'reset',
        text:'Selecione'
      })
      this.permissions = {
        criar_perfil: false,
        listar_perfil: false,
      };
    },

    goTo(path) {
      this.$router.push(path);
    },

    initializeFilters() {
      this.tableUsers.filters = {
        nome: "",
        numero: "",
        cargo:"",
        civil_militar:""
      };

      this.getPerfisList()
    },

    search() {
      this.tableUsers.page = 1;
      this.getUsers(this.createUrlFilters());
    },

    async filterCargos() {

      const cargos = await CargoService.getCargos();
     // console.log(cargos)

        ///console.log(res)
            cargos.content.response.forEach((re) => {
             // console.log(re)
              this.optionsFilter.cargos.push({
                value:re.id,
                text:re.nome
              })
            })

    },

    async getGraduacaoItems() {
      this.loading.field = true;
      const response = await FeriasService.getGraduacao();
      this.optionsFilter.postoGraduacao = response.map((el) => {
        return {
          text: el.descricao,
          value: el.id,
        };
      });
      this.optionsFilter.postoGraduacao?.unshift({
        text: "Selecione",
        value: "",
      });
      this.loading.field = false;
    },

    async filterTipoUsuario () {
      this.optionsFilter.tipoUsuario.push(
        {
          value: null,
          text:'Selecione'
        },
        {
          text: "Civil",
          value: 1,
        },
        {
          text: "Militar",
          value: 2,
        }
      )
    },

    createUrlFilters() {
      let urlFilters = "";

      if(this.tableUsers.filters['cargo'] === "reset") {
        console.log('resetar');
      } else {
        Object.keys(this.tableUsers.filters).forEach((key) => {
          if (this.tableUsers.filters[key]) {
            if (key === 'numero') {
              const numeroBM = this.tableUsers.filters[key].replace(".", "");
              const [numero, digitoVerificador] = numeroBM.split("-");
              urlFilters += `numero=${this.removerZero(numero)}&`;
              if (digitoVerificador) {
                urlFilters += `digito_verificador=${digitoVerificador}&`;
              }
              return;
            }
            urlFilters += `${key}=${this.tableUsers.filters[key]}&`;
          }
        });
      }


      return urlFilters;
    },
    async getPerfis() {
      this.loading.tablePerfis = true;

      const response = await PerfilService.getPerfis();
      this.tablePerfis.data = await response;

      this.loading.tablePerfis = false;
    },
    async getPerfisList() {
      this.loading.field = true;
      const response = await PerfilService.getPerfisList();
      this.optionsFilter.perfis = response.map((el) => {
        return {
          text: el.nome,
          value: el.id,
        };
      });
      this.optionsFilter.perfis?.unshift({
        text: "Selecione",
        value: "",
      });
      this.loading.field = false;
    },
    async getPerfil(id) {
      await PerfilService.showPerfil(id)
    },

    async setCargoUser(user_id) {

      this.dialogShow.cargoUsuarios = !this.dialogShow.cargoUsuarios;
      this.usuarioid = user_id;

    },
    async getUsers( filter = null) {
      this.loading.tableUsers = true;

      const response = PerfilService.getUsersInternos(this.tableUsers.page, filter);

      response.then((res) => {
        const users = res.content.data;
       // this.tableUsers.page = 1;
        this.tableUsers.pageCount = res.content.last_page;
        this.tableUsers.totalItems = res.content.total;

        users.map((user) => {
          let perfisString = 'Sem perfil';
          let cargosString = 'Sem cargos';
          if(typeof user.pessoa_cargo !== "undefined") {
            const cargosStringSet = user.pessoa_cargo.map(function(item) {
              return item.cargo.nome;
            }); //.map((perfil) => perfil.nome);
            // console.log(perfisUser)
            cargosString = cargosStringSet.toString().replace(/,/g, ", ");
          }
          if(typeof user.pessoas_perfis !== "undefined") {
            const perfisUser = user.pessoas_perfis.map(function(item) {
              return item.perfil.nome;
            }); //.map((perfil) => perfil.nome);

            perfisString = perfisUser.toString().replace(/,/g, ", ");
          }
          user.perfisString = perfisString;
          user.cargosString = cargosString;
        });
        this.tableUsers.data = users;
        this.loading.tableUsers = false;

      })

    },

    async getUnidadeItems() {
      this.loading.field = true;
      const response = await FeriasService.getUnidade();
      this.optionsFilter.unidade = response.map((el) => {
        return {
          text: el.nome_abreviado,
          value: el.id,
        };
      });
      this.optionsFilter.unidade?.unshift({
        text: "Selecione",
        value: "",
      });
      this.loading.field = false;
    }, 

    async getLotacaoItems() {
      this.loading.field = true;
      const response = await FeriasService.getLotacao();
      this.optionsFilter.lotacao = response.map((el) => {
        return {
          text: el.nome,
          value: el.id,
        };
      });
      this.optionsFilter.lotacao?.unshift({
        text: "Selecione",
        value: "",
      });
      this.loading.field = false;
    },

    showParametrizar() {
      this.dialogShow.parametrizar_data = !this.dialogShow.parametrizar_data;
    },
    showDialogFuncionalidade(itemid) {

      this.dialogShow.funcionalidades = !this.dialogShow.funcionalidades;
      this.perfiSelectedlid = itemid;
    },

    showDialogAssociacao(userinfo) {
      this.dialogShow.associarPerfil = !this.dialogShow.associarPerfil;
      this.userselected = userinfo;
    },
    async showDialogEditar(perfilid) {
      this.dialogShow.editPerfil = !this.dialogShow.editPerfil;
      this.perfiSelectedlid = perfilid;
      this.perfilid = perfilid;

    },
    async showDialogExcluir(perfilid) {
      this.dialogShow.deletePerfil = !this.dialogShow.deletePerfil;
      this.perfiSelectedlid = perfilid;
      this.perfilid = perfilid;

    },
    async showDialogCargos(perfilid) {

      this.dialogShow.editCargos = !this.dialogShow.editCargos;
      this.perfiSelectedlid = perfilid;
      this.perfilid = perfilid;
    },
    async showDialogParam() {

    },
    perfilCriado(perfilid) {
      this.getPerfis();
      this.showDialogFuncionalidade(perfilid);
    },
    perfilExcluido() {
      this.dialogShow.deletePerfil = !this.dialogShow.deletePerfil;
      this.getPerfis();
    },
    editarPerfil(perfilid) {
      this.showDialogEditar(perfilid); // = true;
    },
    excluirPerfil(perfilid) {
      this.showDialogExcluir(perfilid);
    },
    parametrizarOpen() {

      this.showParametrizar()
    },
    reloadUsers() {
      this.getUsers();
    }
    /*async deletarPerfil(perfilid) {
      //regra removida do sistema
      //const response = await PerfilService.excluirPerfil(perfilid);

     /* if (response.error) {
        const messageError = await response.response;
        this.showSnackbar(messageError, "error");

        return;
      }

      this.showSnackbar("O arquivo foi removido do curso com sucesso");
      this.page = 1;
      this.getPerfis();
    },*/
  },
};